export default "__VITE_ASSET__Du7XS6WQ__"